import React from 'react';
import styled from 'styled-components';
import queryString from 'query-string';

const CardHomePage = ({title, subtitle, link, className, theme, history, onClick, img ,imgRobot,imgResults,imgListchack}) => {

  const handleClick = () => {
    if (link == 'exams/dashboard') {
      const urlEducat = window.location.origin;
      let destino
      switch (urlEducat) {
        case (`http://localhost:3000`):
          destino = `http://localhost:3001`;
          break;

        case (`https://educat-sesi.didatti.net.br`):
          destino = `https://exams-sesi-2022.didatti.net.br`;
          break;

        case (`https://educat-sesi-avaliacao.didatti.net.br`):
          destino = `https://exams-sesi-avaliacao-2022.didatti.net.br`;
          break;

        case (`https://educat-dev-2022.didatti.net.br`):
          destino = `https://exams-dev-2022.didatti.net.br`;
          break;
      }
      const exportLink = `${destino}/exams/dashboard`;
      const pathName = `/external-application-middleware?${queryString.stringify(
        { applicationName: 'exams', path: exportLink, forceLogout: false }
      )}`;

      window.open(pathName, '_self');
    }
    else{
      history.push(link)
    }
  };

  return (
    <div
      className={className}
      onClick={() => { handleClick(); onClick() }}
    >
      <div className='card-left'>
        <div className='div-icon' style={{ backgroundColor: theme, opacity: 0.2 }}>
        </div>
        {img && (<img src={img} alt="img" style={{ width: '31px', position: 'absolute' }} />)}
        {imgRobot && (<img src={imgRobot} alt="imgRobot" style={{ width: '40px', position: 'absolute' }} />)}
        {imgResults && (<img src={imgResults} alt="imgResults" style={{ width: '40px', position: 'absolute' }} />)}
        {imgListchack && (<img src={imgListchack} alt="imgListchack" style={{ width: '38px', position: 'absolute' }} />)}
      </div>
      <div className='card-right'>
        <div className='title'>{title}</div>
        <div className='subtitle'>{subtitle}</div>
      </div>
    </div>
  );
};

export default styled(CardHomePage)`
  height: 100%;
  width: 90%;
  border-radius: 8px;
  width: 400px;
  height: 150px;
  display:flex;
  flex-direction:row;
  background-color:white;
  padding:17px;
  transition: all 0.3s ease;
  box-shadow:
    0px 4px 8px 0px #7277800D,
    0px 2px 4px 0px #7277800D,
    0px 1px 0px 0px #7277800D;



  &:hover {
    background-color: #EAEAEA;
    cursor:pointer;
  }

  .card-left{
    width: 26%;
    height:100%;
    border-radius: 8px;
    display: flex;
    align-items:center;
    justify-content:center;
  }

  .div-icon{
    display:flex;
    align-items:center;
    justify-content:center;
    background-color:white;
    width: 65px;
    height: 65px;
    border-radius:50%;
  }

  .card-right{
    width: 74%;
    height:100%;
    border-radius: 8px;
    display: flex;
    padding-left: 20px;
    justify-content:center;
    flex-direction:column;
  }

  .title{
    font-family: Public Sans;
    font-size: 16px;
    font-weight: 600;
    color: #262930;
  }

  .subtitle{
    font-family: Public Sans;
    font-size: 12px;
    font-weight: 500;
    color: #676A71;

  }
`;
